import { Builder } from '@builder.io/react'
import dynamic from 'next/dynamic'

import { BLOCK_NAMES } from '@/blocks/blockNames'

Builder.registerComponent(
  dynamic<never>(() => import('.').then((mod) => mod.BlogHeroBlock)),
  {
    name: BLOCK_NAMES.blog.hero,
    inputs: [
      {
        name: 'title',
        type: 'string',
        friendlyName: 'Título',
        required: true,
      },
      {
        name: 'category',
        type: 'string',
        friendlyName: 'Categoria',
        hideFromUI: true,
      },
      {
        name: 'image',
        type: 'file',
        friendlyName: 'Imagem',
        required: true,
        allowedFileTypes: ['svg', 'png', 'gif', 'jpg', 'jpeg'],
      },
      {
        name: 'alt',
        type: 'string',
        required: true,
      },
    ],
  },
)
